import type { PropsWithChildren } from 'react';
import type React from 'react';

import { Icon } from '@change-corgi/design-system-legacy/components/icon';
import type { IconComponent } from '@change-corgi/design-system-legacy/icons';
import { Box } from '@change-corgi/design-system-legacy/layout';
import { Heading, Text } from '@change-corgi/design-system-legacy/typography';

type Props = {
	icon: IconComponent;
	iconColor: string;
	background?: string;
	headingColor?: string;
};

export const PetitionStatusHeader: React.FC<PropsWithChildren<Props>> = ({
	iconColor,
	icon,
	background,
	headingColor,
	children,
}) => {
	return (
		<Box p={8} sx={{ textAlign: 'center', background, borderRadius: '8px' }}>
			<Text as="div" sx={{ display: 'inline-flex', alignItems: 'center' }}>
				<Icon icon={icon} size="xl" color={iconColor} mr={8} />
				<Heading size="h3" as="span" color={headingColor} ellipsis>
					{children}
				</Heading>
			</Text>
		</Box>
	);
};
